export function shouldPreserveBrowserCopy(selection: Selection | null): boolean {
  return (selection?.toString() ?? '').length > 0
}
